module.exports = __webpack_public_path__ + "i18n/de.ff63e55bbee4e86f893885d246470133.json";